import styled, { isTrellisTheme } from 'foundations-theming/utils';
import { devices } from 'signup-constants/styles/viewports.styles';
import { AnimatedButton } from 'signup-components/styles/ButtonAnimations.styles';
import { getStepConfig } from '../views/getStepConfig';
import { LayoutType } from 'signup-components/types';
import { isLeftAlignedLayout } from '../utils/isLeftAlignedLayout';
const getButtonColumnCountEmbedded = currentStep => {
  const stepConfig = getStepConfig(currentStep);
  const stepButtonColumnConfig = stepConfig && stepConfig.stepToButtonColumn;
  return stepButtonColumnConfig && stepButtonColumnConfig.embedded ? stepButtonColumnConfig.embedded : 1;
};
const getButtonColumnCountDesktop = (currentStep, isEmbedded, isFramedCentredStepLayout) => {
  const stepConfig = getStepConfig(currentStep);
  const stepButtonColumnConfig = stepConfig && stepConfig.stepToButtonColumn;
  if (isEmbedded || isFramedCentredStepLayout) {
    return getButtonColumnCountEmbedded(currentStep);
  }
  return stepButtonColumnConfig ? stepButtonColumnConfig.default : 2;
};
const getButtonColumnCountMobile = (currentStep, isEmbedded) => {
  const stepConfig = getStepConfig(currentStep);
  const stepButtonColumnConfig = stepConfig && stepConfig.stepToButtonColumn;
  if (isEmbedded) {
    return getButtonColumnCountEmbedded(currentStep);
  }
  return stepButtonColumnConfig && stepButtonColumnConfig.mobile ? stepButtonColumnConfig.mobile : 1;
};
export const getButtonColumnCount = (currentStep, isMobile, isEmbedded, isFramedCentredStepLayout) => {
  if (isMobile) {
    return getButtonColumnCountMobile(currentStep, isEmbedded);
  }
  if (isEmbedded || isFramedCentredStepLayout) {
    return getButtonColumnCountEmbedded(currentStep);
  }
  return getButtonColumnCountDesktop(currentStep, isEmbedded, isFramedCentredStepLayout);
};
export const ButtonsGridStyled = styled.div.withConfig({
  displayName: "ButtonsGridstyles__ButtonsGridStyled",
  componentId: "sc-7xd3u5-0"
})(["--column-count:", ";", " @media ", "{--column-count:", ";", "}--total_columns:calc(var(--column-count) * 2);--span:calc(var(--total_columns) / var(--column-count));display:grid;grid-template-columns:repeat(var(--total_columns),minmax(0,1fr));grid-auto-rows:auto;grid-gap:", ";& > *{grid-column:span var(--span);", "}", ""], props => props.$columnCount || getButtonColumnCountMobile(props.$currentStep, props.embedded), props => props.$layoutType === LayoutType.SidePanel && `max-width: 800px;`, devices.desktop, props => props.$columnCount || getButtonColumnCountDesktop(props.$currentStep, props.embedded, props.$isFramedCentredStepLayout), props => isLeftAlignedLayout(props.$layoutType) && (getButtonColumnCountDesktop(props.$currentStep, props.embedded, props.$isFramedCentredStepLayout) === 1 || props.$columnCount === 1) && `width: 420px;`, props => props.$layoutType === LayoutType.SidePanel ? '16px 0;' : '20px', props => props.$shouldCenter && `	&:nth-last-child(${props.$offset}):nth-child(${props.$nthChild}) {
			grid-column: var(--span) / span var(--span);
		}`, props => props.$addTopPadding && `padding-top: 20px;`);
export const ButtonsGridButtonHolder = styled.div.withConfig({
  displayName: "ButtonsGridstyles__ButtonsGridButtonHolder",
  componentId: "sc-7xd3u5-1"
})(["min-height:", ";min-width:0;display:grid;", " @media ", "{", "}"], ({
  minHeight
}) => minHeight || '5rem', props => props.isSidePanel && `margin-right: 16px;`, devices.desktop, props => props.isSidePanel && `max-width: 400px;`);
export const ButtonsGridButton = styled(AnimatedButton).withConfig({
  displayName: "ButtonsGridstyles__ButtonsGridButton",
  componentId: "sc-7xd3u5-2"
})(["height:100%;p{font-size:17px;font-weight:400;}@media ", "{p{font-size:17px;}&:focus{outline:none;box-shadow:0 0 0 2px ", ";}}@media ", "{p{font-size:17px;}&:focus{outline:none;box-shadow:0 0 0 2px ", ";}}"], devices.desktop, ({
  theme
}) => theme.color['do-not-use-calypso-medium'], devices.tablet, ({
  theme
}) => theme.color['do-not-use-calypso-medium']);
export const StyledIllustrationContainer = styled.div.withConfig({
  displayName: "ButtonsGridstyles__StyledIllustrationContainer",
  componentId: "sc-7xd3u5-3"
})(["text-align:center;margin-top:20px;padding-top:10px;min-width:90px;min-height:90px;"]);
export const StyledButtonText = styled.p.withConfig({
  displayName: "ButtonsGridstyles__StyledButtonText",
  componentId: "sc-7xd3u5-4"
})(["font-weight:600 !important;margin:0 !important;", " ", " ", ""], ({
  theme
}) => isTrellisTheme(theme) && `color: ${theme.color['text-core-default']} !important;`, props => props.isHubletButtonText && `padding-top: 5px; text-align: left;`, props => props.isSidePanel && `font-weight: ${props.theme.typography['body-125'].fontWeight} !important;
    font-size: ${props.theme.typography['body-125'].fontSize} !important;`);